<div class="my-5">
  <!-- page-header -->
  <sm-page-header
    [breadcrumb]="breadcrumb"
    title="settings.companyInfo.update.title"
    description="settings.companyInfo.update.description"
  ></sm-page-header>
  <!-- content -->
  <div class="content" *ngIf="!formDateLoading">
    <sm-form-builder [formObject]="formObject" class="w-full px-4"></sm-form-builder>
    <div class="flex justify-end gap-2">
      <p-button label="Modifier" (click)="updateCompany()" />
      <p-button label="Réinitialiser" severity="secondary" />
    </div>

    <p-tabs [(value)]="selectedTab" (valueChange)="onTabChange($event)" scrollable class="mt-4 bg-transparent">
      <p-tablist>
        <p-tab value="0">{{ 'settings.companyInfo.tabs.contacts' | translate }}</p-tab>
        <p-tab value="1">{{ 'settings.companyInfo.tabs.addresses' | translate }}</p-tab>
        <p-tab value="2">{{ 'settings.companyInfo.tabs.bankDetails' | translate }}</p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="0">
          <sm-contact [companyId]="id"></sm-contact>
        </p-tabpanel>
        <p-tabpanel value="1">
          <sm-address [companyId]="id"></sm-address>
        </p-tabpanel>
        <p-tabpanel value="2">
          <sm-bank-details [companyId]="id"></sm-bank-details>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>
  <sm-spinner [loading]="formDateLoading"></sm-spinner>
</div>
